import {collection, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {SellableReportSelectionData} from "../../sellable/controls/sellable-report-selection-control.component";

export class ProductPluReportData extends LocalisableEntityData<ProductPluReportData> {
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
}
